import type { IconSvgObject } from './types';

const GaugeIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "16", r: "2", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 14V10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default GaugeIcon;
